import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { pushEvent } from "@/lib/tracking";

/**
 * Component that tracks SPA route changes and pushes page_view events to dataLayer.
 * Must be rendered inside a BrowserRouter.
 * 
 * Avoids duplicate events for the same consecutive page_path using a ref.
 */
export function RouteChangeTracker() {
  const location = useLocation();
  const lastPagePath = useRef<string | null>(null);

  useEffect(() => {
    const currentPagePath = location.pathname + location.search;

    // Avoid duplicate page_view for the same path
    if (lastPagePath.current === currentPagePath) {
      return;
    }

    lastPagePath.current = currentPagePath;

    // Small delay to ensure document.title is updated after route change
    const timeoutId = setTimeout(() => {
      pushEvent("page_view", {
        referrer: document.referrer || undefined,
      });
    }, 0);

    return () => clearTimeout(timeoutId);
  }, [location.pathname, location.search]);

  return null;
}
